<template>
  <div class="warning-connect-wallet-container">
    <img class="img-container" src="@/assets/images/wallet.png" alt="wallet" />
    <div class="content">
      Please connect to your wallet first
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  methods: {}
};
</script>

<style lang="scss" scoped>
.warning-connect-wallet-container {
  color: #354165;
  width: 370px;
  height: 150px;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;

  .img-container {
    width: 42px;
    object-fit: contain;
  }

  .content {
    text-align: center;
  }
}
</style>
